import * as React from 'react'

export const PasswordChangeSuccess = () => (
  <>
    <h4 className="text-secondary fw-bold text-center mt-5 mb-2">Twoje hasło zostało zmienione</h4>
    <p className="mb-4 mt-3 text-center font-size-12">Możęsz już korzystać ze swojego Konta Gościa</p>
  </>
)
